/**
 * Discovery types — Katalog App
 * Replaces mock data imports from kloutforce-app.
 */

export interface FacetItem {
  id: string;
  label: string;
  count: number;
  miniItems: string[];
}

/** Get industry label by ID - returns the ID as fallback (no mock data) */
export function getIndustryLabel(id: string): string {
  return id;
}

/** Get category label by ID - returns the ID as fallback (no mock data) */
export function getCategoryLabel(id: string): string {
  return id;
}

/** Get subcategory label by ID - returns the ID as fallback (no mock data) */
export function getSubcategoryLabel(id: string): string {
  return id;
}
